import * as AC from './actionTypes';

export const getCustomerCards = (customerId, filters) => ({
  type: AC.GET_CUSTOMER_CARDS_REQUEST,
  customerId,
  filters,
});

export const getOverusedCards = (filters = {}) => ({
  type: AC.GET_FREQUENTLY_USED_CARDS_REQUEST,
  filters,
});

export const getAllCustomerCards = customerId => ({
  type: AC.GET_ALL_CUSTOMER_CARDS_REQUEST,
  customerId,
});

export const getCardDetails = id => ({
  type: AC.GET_CARD_DETAILS_REQUEST,
  id,
});

export const addCard = (
  customerId,
  elevatorId,
  siteCode,
  siteNo,
  code,
  access,
) => ({
  type: AC.ADD_CARD_REQUEST,
  payload: {customerId, elevatorId, siteCode, siteNo, code, access},
});

export const editCard = (
  customerId,
  elevatorId,
  siteCode,
  siteNo,
  code,
  access,
  cardId,
) => ({
  type: AC.EDIT_CARD_REQUEST,
  payload: {customerId, elevatorId, siteCode, siteNo, code, access, cardId},
});

export const reactivateCards = customerId => ({
  type: AC.REACTIVATE_CARD_REQUEST,
  customerId,
});

export const deleteCard = cardId => ({
  type: AC.DELETE_CARD_REQUEST,
  cardId,
});

export const activateAllCards = customerId => ({
  type: AC.ACTIVATE_ALL_CARDS_REQUEST,
  customerId,
});

export const deactivateAllCards = customerId => ({
  type: AC.DEACTIVATE_ALL_CARDS_REQUEST,
  customerId,
});

export const assignCards = (cardIds, elevatorId, customerId) => ({
  type: AC.ASSIGN_CARDS_REQUEST,
  payload: {cardIds, elevatorId, customerId},
});

export const getCardsByElevator = (customerId, elevatorId) => ({
  type: AC.GET_CARDS_BY_ELEVATOR_REQUEST,
  customerId,
  elevatorId,
});

export const removeCardsByElevator = () => ({
  type: AC.REMOVE_CARDS_BY_ELEVATOR,
});
